/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'linkedin': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _fill="#010101"><path pid="0" d="M0 5.164h3.418V16H0zM1.964 0C.8 0 0 .8 0 1.818s.727 1.818 1.891 1.818c1.164 0 1.964-.8 1.964-1.818S3.127 0 1.964 0zM12.073 5.164c-1.818 0-2.618 1.018-3.055 1.745V5.164H5.6C5.673 6.182 5.6 16 5.6 16h3.418v-5.964c0-.291 0-.654.145-.873.218-.654.8-1.309 1.745-1.309 1.236 0 1.745.945 1.745 2.4V16H16V9.964c0-3.273-1.673-4.8-3.927-4.8z"/></g>'
  }
})
